
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_19zni_97",
  "button": "awsui_button_vjswe_19zni_101",
  "variant-normal": "awsui_variant-normal_vjswe_19zni_126",
  "is-activated": "awsui_is-activated_vjswe_19zni_139",
  "hide-focus-outline": "awsui_hide-focus-outline_vjswe_19zni_148",
  "force-focus-outline": "awsui_force-focus-outline_vjswe_19zni_166",
  "variant-icon": "awsui_variant-icon_vjswe_19zni_184",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_19zni_184",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_19zni_184",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_19zni_202",
  "disabled": "awsui_disabled_vjswe_19zni_220",
  "variant-primary": "awsui_variant-primary_vjswe_19zni_228",
  "variant-link": "awsui_variant-link_vjswe_19zni_330",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_19zni_840",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_19zni_945",
  "button-no-text": "awsui_button-no-text_vjswe_19zni_1047",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_19zni_1051",
  "icon-left": "awsui_icon-left_vjswe_19zni_1067",
  "icon-right": "awsui_icon-right_vjswe_19zni_1072",
  "icon": "awsui_icon_vjswe_19zni_1067"
};
  